"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Manager = void 0;

var _cache = require("../cache");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Manager = /*#__PURE__*/function () {
  function Manager(name, config) {
    _classCallCheck(this, Manager);

    _defineProperty(this, "_config", void 0);

    _defineProperty(this, "_cache", void 0);

    this._config = config;
    this._cache = new _cache.Cache('Config/' + name); // @TODO: 之后用封装的 URL 库解决问题

    if (/config-manager=1/.test(location.search)) {
      this._cache.set('enable', true);
    }

    if (this._cache.get('enable')) {
      this._config.pushLayer('manager', this._cache.get('content') || {});
    }
  }

  _createClass(Manager, [{
    key: "_reload",
    value: function _reload() {
      alert('配置已更新，确认后刷新页面');
      location.reload();
    }
  }, {
    key: "set",
    value: function set(config) {
      this._cache.set('content', config);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._cache.clear();

      this._reload();
    }
  }]);

  return Manager;
}();

exports.Manager = Manager;


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/config/manager.js
// module id = 619
// module chunks = 6